import { render, staticRenderFns } from "./SmallPaymentMethodSelector.vue?vue&type=template&id=657041f5&scoped=true"
import script from "./SmallPaymentMethodSelector.vue?vue&type=script&lang=js"
export * from "./SmallPaymentMethodSelector.vue?vue&type=script&lang=js"
import style0 from "./SmallPaymentMethodSelector.vue?vue&type=style&index=0&id=657041f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657041f5",
  null
  
)

export default component.exports